<template>
	<div class="page">

		<!-- 搜索条件表单 -->
		<el-form class="ser_form" size="small"  label-width="68px">
			<el-form-item class="el_form_item" label="用户姓名">
				<el-input class="el_input" v-model="form.name" placeholder="用户姓名搜索" clearable></el-input>
			</el-form-item>
			<el-form-item class="el_form_item" label="用户手机">
				<el-input class="el_input" v-model="form.tel" placeholder="用户手机号搜索" clearable></el-input>
			</el-form-item>
			<el-form-item class="el_form_item" label="推荐人">
				<el-input class="el_input" v-model="form.agent_tel" placeholder="推荐人手机号搜索" clearable></el-input>
			</el-form-item>
			<el-form-item class="el_form_item" label="身份证号">
				<el-input class="el_input" v-model="form.id_card_num" placeholder="推荐人手机号搜索" clearable></el-input>
			</el-form-item>
			<el-form-item class="el_form_item" label="实名认证">
				<el-select class="el_input" v-model="form.real_status" clearable>
					<el-option label="不限" value=""></el-option>
					<el-option label="未认证" value="1"></el-option>
					<el-option label="已通过" value="2"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item class="el_form_item" label="用户状态">
				<el-select class="el_input" v-model="form.status" clearable>
					<el-option label="不限" value=""></el-option>
					<el-option label="正常" value="1"></el-option>
					<el-option label="停用" value="2"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item class="el_form_item" label="用户性别">
				<el-select class="el_input" v-model="form.sex" clearable>
					<el-option label="不限" value=""></el-option>
					<el-option label="男" value="1"></el-option>
					<el-option label="女" value="2"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item class="el_form_item elfrom_item" label="创建时间">
				<div class="block">
				<el-date-picker
					v-model="build_date"
					type="datetimerange"
					:picker-options="pickerOptions"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					align="right"
					value-format="timestamp"
				>
				</el-date-picker>
				</div>
			</el-form-item>
			<el-form-item class="el_form_item"></el-form-item>
			<el-form-item label-width="0" id="button">
				<el-button type="primary" @click="page_ser">查询</el-button>
				<el-button type="primary" @click="ser_para_clear">清空条件</el-button>
				<el-button type="success" @click="open_add_view">添加</el-button>
				<el-button type="success" @click="set_ide_code">设置短信验证码</el-button>
				<el-button type="success" @click="batch_app_user_edit_by_admin(0)">批量驳回</el-button>
			</el-form-item>
		</el-form>
		<div class="total_info item">
			<span>共:{{ list.total }}条</span>
		</div>
		<!-- 表格 -->
		<div class="tab_height">
			<el-table :data="list.data" :border="true" :stripe="true" size="small" height="100%" v-loading="list.loading" @selection-change="user_list_choose">
				<el-table-column type="selection" width="39px"></el-table-column>
				<el-table-column width="100" label="ID" prop="id"></el-table-column>
				<el-table-column label="用户编号" prop="user_num"></el-table-column>
				<el-table-column label="注册时间" prop="creat_time_text"></el-table-column>
				<el-table-column label="电话号码" prop="tel"></el-table-column>
				<el-table-column label="真实姓名" prop="name"></el-table-column>
				<el-table-column label="实名状态" prop="real_status_text"></el-table-column>
				<el-table-column label="账户状态" prop="status_text"></el-table-column>
				<el-table-column label="备注" prop="mark"></el-table-column>
				<!-- 操作行 -->
				<el-table-column label="操作" width="190">
					<template slot-scope="scope">
						
						<!-- 停用/启用 -->
						<el-button v-if="scope.row.status==1" @click="user_status_edit(scope.row.id,2)" size="mini" type="text">停用</el-button>
						<el-button v-if="scope.row.status==2" @click="user_status_edit(scope.row.id,1)" size="mini" type="text">启用</el-button>
						<el-button v-if="scope.row.pay_status==1" @click="user_payments_edit(scope.row.id,2)" size="mini" type="text">关闭支付</el-button>
						<el-button v-if="scope.row.pay_status==2" @click="user_payments_edit(scope.row.id,1)" size="mini" type="text">开启支付</el-button>
						<!-- 其他 -->
						
						<el-button @click="user_info_view_open(scope.row)" size="mini" type="text">详情</el-button>
						<el-button @click="bankcard_relieve_record(scope.row)" class="btn_left" size="mini" type="text">解绑卡操作记录</el-button>
						<el-button @click="admin_psw_reset(scope.row)"  size="mini" type="text">重置密码</el-button>
						<el-button @click="app_user_edit_by_admin(scope.row)" class="btn_left"  size="mini" type="text">实名驳回</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 分页 -->
		<el-pagination 
			class="margin-top-xl" 
			@size-change="page_size_change"
			@current-change="page_current_change" 
			:current-page="page.p" 
			:page-sizes="[10, 20, 30, 40]"
			:page-size="page.num" 
			:total="list.total*1"
			layout="total, sizes,prev, pager, next, jumper" 
		></el-pagination>

		<!-- 用户详情 -->
		<userInfo 
			:user_info="user_info.data" 
			:is_show="user_info.is_show" 
			@list_refresh="get_page_data"
			@edit_success ="get_page_data"
		></userInfo>

		<!-- 用户添加 -->
		<userAdd 
			:is_show="user_add.is_show" 
			@list_refresh="get_page_data" 
		></userAdd>
		<!-- 临时验证码 -->
		<el-dialog
				title="临时验证码"
				:visible.sync="set_id.is_show"
				width="300px"
				top="30vh"
			>
			<el-input class="el_input" style="margin-top: 10px;" v-model="set_id.ide_code" placeholder="请输入临时验证码" clearable></el-input>
			<div style="margin-top: 20px;">
				<el-date-picker
				v-model="set_id.end_time"
				type="datetime"
				placeholder="选择验证码到期时间">
				</el-date-picker>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="set_id.is_show = false">取 消</el-button>
				<el-button type="primary" @click="set_ide_code_sub">确 定</el-button>
			</span>
		</el-dialog>
		<!--重置密码  -->
		<el-dialog
				title="重置密码"
				:visible.sync="reset_psw.is_show"
				width="400px"
				top="30vh"
				@close="admin_psw_reset_colse"
			>
			<el-select class="el_input" v-model="reset_psw.type" placeholder="密码重置类型"  clearable>
				<el-option label="登录密码" value="1"></el-option>
				<el-option label="支付密码" value="2"></el-option>
			</el-select>
			<el-input class="el_input" style="margin-top: 20px;" v-model="reset_psw.login_pwd"  :show-password="true" type="password" placeholder="请输入登录密码" clearable></el-input>
			<div class="psw_tip">
				登录密码需包含字母，符号，数字，长度至少6位字符
			</div>
			<el-input class="el_input" style="margin-top: 20px;" v-model="reset_psw.pay_pwd"  :show-password="true" type="password" placeholder="请输入支付密码" clearable></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="reset_psw.is_show = false">取 消</el-button>
				<el-button type="primary" @click="admin_psw_reset_sub">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog
			title="用户解绑卡操作记录"
			:visible.sync="bankcard_relieve_list_show"
			width="80%"
			top="10vh"
		>
		     <el-table :data="bankcard_relieve_list" :border="true" :stripe="true" size="small" height="800px">
                    <el-table-column label="id">
                            <template slot-scope="scope">
                                <div class="tab_line_item">{{scope.row.id}}</div>
                            </template>
                        </el-table-column>
                       <el-table-column label="解绑时间">
                            <template slot-scope="scope">
                                <div>{{scope.row.time_text}}</div>
                            </template>
                        </el-table-column>
                       <el-table-column label="解绑操作">
                            <template slot-scope="scope">
                                <div>{{scope.row.desc}}</div>
                            </template>
                        </el-table-column>
                         <el-table-column label="备注">
                            <template slot-scope="scope">
                                <div>{{scope.row.mark}}</div>
                            </template>
                        </el-table-column>
                    </el-table>
		</el-dialog>
	</div>
</template>

<script>
	import userInfo from './info.vue'
	import userAdd from './add.vue'
	import { Loading } from "element-ui";
	export default {
		components:{
			userInfo,
			userAdd,
		},
		data() {
			return {
				bankcard_relieve_list_show:false,
				bankcard_relieve_list:[],
				//搜索条件
				form: {				
					name:'',//姓名
					tel:'',//电话
					agent_tel:'',//是否可用
					id_card_num:'',//身份证号
					real_status:'2',//实名状态(1:未审核,2:审核通过,3:审核失败)
					status:'',//状态
					sex:'',//性别
				},

				//表格数据
				list: {
					loading: false,//loading特效
					data: [],//列表数据
					total: 0,//列表总记录数
				},

				//页码信息
				page: {
					need_num:1,
					num: 10,
					p: 1,
				},
				//重置密码
				reset_psw:{
					is_show:false,
					pay_pwd:'',//支付密码
					login_pwd:'',//登录密码
					type:'',//当前重置密码类型
					user_num:'',//用户编号
				},
				build_date:'',//创建时间
				creat_time_start:'', //开始时间
				creat_time_end:'', //结束时间
				//时间快捷操作
			    pickerOptions: {
					shortcuts: [
					{
						text: "最近一周",
						onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit("pick", [start, end]);
						},
					},
					{
						text: "最近一个月",
						onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit("pick", [start, end]);
						},
					},
					{
						text: "最近三个月",
						onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit("pick", [start, end]);
						},
					},
					],
				},
				//用户详情
				user_info:{
					data:{},
					is_show:0,
				},

				//用户添加
				user_add:{
					is_show:0,
				},
				//临时验证码
				set_id:{
					is_show:false,
					ide_code:'',
					end_time:'',
				},
				tords_choosed:[]//勾选数据
			}
		},
		created() {
			console.log('重庆重庆市九龙坡区九龙坡区谢家湾正街55号重庆万象城L120​')
			//获取可用搜索参数
			this.get_page_data()
		},
		methods: {
			//勾选
			user_list_choose(event){
				//置入
				this.tords_choosed=event
			},
			//批量驳回
			batch_app_user_edit_by_admin(n){
				var choosed = this.tords_choosed
				if (choosed.length == 0) {
					this.$my.other.msg({
						type: "info",
						str: '当前未勾选数据'
					});
					return
				}
				if(n==choosed.length){
					this.$my.other.msg({
						type:'success',
						str:'操作完毕'
					});
					//刷新
					this.get_page_data()
					let loadingInstance = Loading.service(this.options);
						this.$nextTick(() => {
						loadingInstance.close();
					});
					return
				}
				if(n==0){
					//询问
					this.$my.other.confirm({
						content:"是否批量驳回?",
						confirm:()=>{
							Loading.service(this.options);
							//调接口
							this.$my.net.req({
								take_over_control:1,
								data:{
									mod:'app_user',
									ctr:'app_user_edit_by_admin',
									user_num:choosed[n].user_num,
									real_status:1
								},
								callback:(data)=>{
									if(data.code !=0){
										this.$my.other.msg({
											type:'info',
											str:data.error_info
										});
										let loadingInstance = Loading.service(this.options);
											this.$nextTick(() => {
											loadingInstance.close();
										});
										return
									}
									// this.$my.other.msg({
									// 	type:'success',
									// 	str:'驳回成功'
									// });
									n++
									this.batch_app_user_edit_by_admin(n)
								},
							});
						}
					});
				}else{
					this.$my.net.req({
						take_over_control:1,
						data:{
							mod:'app_user',
							ctr:'app_user_edit_by_admin',
							user_num:choosed[n].user_num,
							real_status:1
						},
						callback:(data)=>{
							if(data.code !=0){
								this.$my.other.msg({
									type:'info',
									str:data.error_info
								});
								let loadingInstance = Loading.service(this.options);
									this.$nextTick(() => {
									loadingInstance.close();
								});
								return
							}
							// this.$my.other.msg({
							// 	type:'success',
							// 	str:'驳回成功'
							// });
							n++
							this.batch_app_user_edit_by_admin(n)
						},
					});
				}


			},
			//实名驳回
			app_user_edit_by_admin(item){
					//询问
					this.$my.other.confirm({
						content:"是否实名驳回?",
						confirm:()=>{
							//调接口
							this.$my.net.req({
								data:{
									mod:'app_user',
									ctr:'app_user_edit_by_admin',
									user_num:item.user_num,
									real_status:1
								},
								callback:(data)=>{
									this.$my.other.msg({
										type:'success',
										str:'驳回成功'
									});
									//刷新
									this.get_page_data()
								},
							});
						}
					});

			},
			admin_psw_reset_colse(){
				this.reset_psw={
					is_show:false,
					pay_pwd:'',//支付密码
					login_pwd:'',//登录密码
					type:'',//当前重置密码类型
					user_num:'',//用户编号
				}
			},

			//重置密码提交
			admin_psw_reset_sub(){
			    this.$my.net.req({
					data:{
						mod:'app_user',
						ctr:'reset_pwd_by_admin',
						type:this.reset_psw.type,
						login_pwd:this.reset_psw.login_pwd,
						pay_pwd:this.reset_psw.pay_pwd,
						user_num:this.reset_psw.user_num
					},
					callback:(data)=>{
						this.$my.other.msg({
							type:'success',
							str:'重置密码成功'
						});
						//清空
						this.admin_psw_reset_colse()
						//刷新
						this.get_page_data()
					},
				});
			},
			//重置密码
			admin_psw_reset(item){
				this.reset_psw.is_show = true
				this.reset_psw.user_num = item.user_num
			},
			//银行卡操作解绑记录
			bankcard_relieve_record(item){
				this.$my.net.req({
					data:{
						mod:'app_user',
						ctr:'bankcard_relieve_record',
						user_num:item.user_num,
					},
					callback:(data)=>{
						for(let item of data.list){
							item.time_text = this.$my.other.totime(item.time);
						}
						this.bankcard_relieve_list= data.list
						this.bankcard_relieve_list_show = true
					},
				});
			},
			set_ide_code_sub(){
				if(!this.set_id.ide_code){
					this.$my.other.msg({
						type:'info',
						str:'缺少临时验证码'
					});
					return
				}
			    this.$my.net.req({
					data:{
						mod:'admin',
						ctr:'set_ide_code',
						ide_code:this.set_id.ide_code,
						end_time:new Date(this.set_id.end_time).getTime()/1000,
					},
					callback:(data)=>{
						this.$my.other.msg({
							type:'success',
							str:'设置成功'
						});
						//清空
						this.set_id.is_show =false
						this.set_id.ide_code =''
						this.set_id.end_time =''
						//刷新
						this.get_page_data()
					},
				});
			},
			set_ide_code(){
				this.set_id.is_show = true
			},
			//支付开启/关闭
			user_payments_edit(uid,new_status){
				//提交
				this.$my.net.req({
					data:{
						mod:'app_user',
						ctr:'app_user_edit_by_admin',
						id:uid,
						pay_status:new_status,
					},
					callback:(data)=>{
						if(new_status ==1){
							this.$my.other.msg({
								type:'success',
								str:'支付功能已开启'
							});
						}else{
							this.$my.other.msg({
								type:'success',
								str:'支付功能已关闭'
							});
						}
						

						//刷新
						this.get_page_data()
					},
				});
			},
			//修改用户状态
			user_status_edit(uid,new_status){

				//提交
				this.$my.net.req({
					data:{
						mod:'app_user',
						ctr:'app_user_edit_by_admin',
						id:uid,
						status:new_status
					},
					callback:(data)=>{
						this.$my.other.msg({
							type:'success',
							str:'操作成功'
						});

						//刷新
						this.get_page_data()
					},
				});
			},

			//打开用户详情
			user_info_view_open(item){
				
				//置入数据
				this.user_info.data=item

				//打开弹出层
				this.user_info.is_show++
			},
			//关闭用户详情
			user_info_view_close(item){

				//关闭弹出层
				this.user_info.is_show=0;
				
				//清空数据
				this.user_info.data={}
			},

			//前往添加页面
			open_add_view(){
				this.user_add.is_show++
			},

			//前往修改页面
			open_edit_view(item){
				this.get_menu_list()
				this.edit_para.user_info=item
				this.edit_para.is_show=true
			},

			//清空查询条件
			ser_para_clear(){
				this.form={
					name:'',//姓名
					tel:'',//电话
					agent_tel:'',//是否可用
					id_card_num:'',//身份证号
					real_status:'2',//实名状态(1:未审核,2:审核通过,3:审核失败)
					status:'',//状态
					sex:'',//性别
				}
				this.get_page_data()
			},

			//搜索
			page_ser(){

				//读取第一页
				this.page.p=1

				//读取
				if (this.build_date) {
					this.form.creat_time_start = parseInt(this.build_date[0] / 1000);
					this.form.creat_time_end = parseInt(this.build_date[1] / 1000);
					this.page.p = 1;
					this.get_page_data();
				} else {
					this.form.creat_time_start = "";
					this.form.creat_time_end = "";
					this.page.p = 1;
					this.get_page_data();
				}
			},

			//页宽变化
			page_size_change(num){

				//置入页码
				this.page.num=num

				//读取
				this.get_page_data()
			},

			//页码变化
			page_current_change(p){
				
				//置入页码
				this.page.p=p

				//读取
				this.get_page_data()
			},

			//获取后台用户
			get_page_data(){

				//加载中...
				if(this.list.loading){
					return;
				}

				//置为加载中
				this.list.loading=true;

				//读取数据
				this.$my.net.req({
					data:{
						mod:'app_user',
						ctr:'app_user_list_by_admin',
						...this.form,
						...this.page
					},
					callback:(data)=>{

						//加载完毕
						this.list.loading=false

						//总数
						this.list.total=data.max

						//预处理
						for(let item of data.list){
							
							//下单时间
							item.creat_time_text=this.$my.other.totime(item.creat_time);

							//实名状态
							switch(item.real_status){
								case '1':item.real_status_text='未实名';break;
								case '2':item.real_status_text='已实名';break;
							}

							//账户状态
							switch(item.status){
								case '1':item.status_text='正常';break;
								case '2':item.status_text='停用';break;
							}
						}

						//渲染
						this.list.data=data.list
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>

	//弹出层
	.in_tab_img_item{
		width: 300px;
	}

	//用户修改/添加表单的额外权限菜单部分
	.menu_list{
		background-color:#eee;
		height: 500px;
		overflow: auto;
		padding: 0 20px;
		margin-top: 10px;
		.children_list{
			margin-left: 20px;
		}
	}

	//其他
	.page{
		background-color: #fff;
		padding: 20px;
		border-radius: 10px;
		height: calc(100% - 40px);
		overflow: auto;
	}
	.ser_form{
		display: flex;
		align-items: flex-end;
		flex-wrap: wrap;
	}
	.tab_height{
		height:calc(100% - 140px);
	}
	.el_form_item{
		width: 20%;
	}
	.el_input{
		width:94%
	}
	.btn_left{
		margin-left: 0px;
	}
	.total_info {
	text-align: right;
	font-size: 12px;
	margin-bottom: 24px;
	margin-right: 1px;
	margin-top: 10px;
	color: #606266;
		span {
			margin-left: 20px;
		}
	}
	.item {
	font-weight: 800;
	}
	#button{
		margin-left: -120px;
	}
	.psw_tip{
		font-size: 12px;
		color: red;
		margin: 10px 0px 0px 5px;
	}
</style>